import {LinksSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/links_section.types';
import {useTranslation} from '@aboutyou/i18n';
import {useCanGoBack, useHistory} from '@aboutyou/router';
import {
  COLORS,
  GenericIconName,
  HeaderButtonProps,
  IconSize,
} from '@aboutyou/ui-components';
import React from 'react';
import {useBackButtonTracking} from '../BrandHubTracking/hooks/useBackButtonTracking';

interface BrandPageBackButtonProps {
  className?: string;
  BackButtonComponent: React.ComponentType<HeaderButtonProps>;
  linksSection: LinksSection;
  iconSize?: keyof typeof IconSize;
  iconColor?: COLORS;
  backgroundColor?: COLORS | 'transparent';
  hideLabel?: boolean;
}

export const BrandPageBackButton: React.FC<BrandPageBackButtonProps> = ({
  className,
  BackButtonComponent,
  linksSection,
  iconColor,
  backgroundColor,
  iconSize,
  hideLabel,
}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const canGoBack = useCanGoBack();
  const trackBackButtonClick = useBackButtonTracking();

  if (!linksSection) {
    return null;
  }

  const {backLinkLabel, backLinkTarget} = linksSection;
  const label = (() => {
    if (hideLabel) {
      return '';
    }

    if (canGoBack) {
      return t('Back');
    }

    return backLinkLabel ?? '';
  })();

  const goBack = () => {
    trackBackButtonClick();
    if (canGoBack) {
      history.goBack();
    } else if (backLinkTarget) {
      history.push(backLinkTarget.url);
    }
  };

  return (
    <BackButtonComponent
      className={className}
      dataTestId={'RoundBackButton'}
      label={label}
      icon={GenericIconName.ArrowLeft}
      iconColor={iconColor}
      iconSize={iconSize}
      backgroundColor={backgroundColor}
      onClick={goBack}
    />
  );
};
